/** Active scope tabs on GET /projects (API uses `active` / `include_inactive`, not filters[].active). */
export const PROJECT_LIST_VIEWS = ["active", "inactive", "all"];

/**
 * Legacy: derive tab from filters JSON that stored `{ name: "active", value: "true|false" }`.
 */
export function projectsListViewFromFilters(filters) {
  const af = (filters || []).find((f) => f?.name === "active");
  if (!af) return "all";
  return String(af.value) === "false" ? "inactive" : "active";
}

/** Map list tab / scope to query params understood by ProjectsController#index. */
export function projectsActiveQueryParams(viewOrScope) {
  const view = String(viewOrScope || "active");
  if (view === "inactive") {
    return { active: "false" };
  }
  if (view === "all") {
    return { include_inactive: "true" };
  }
  return { active: "true" };
}

function stripActiveFilterRules(rules) {
  return (rules || []).filter((f) => f?.name !== "active");
}

/**
 * Build GET /projects params with correct active/inactive scope.
 *
 * @param {object} baseParams - page, sort, query, fields, offer_scope, filters (customer/contact/department)
 * @param {object} [options]
 * @param {string} [options.listView] - active | inactive | all
 * @param {boolean} [options.activeOnly] - true = active only; false = include inactive (all statuses)
 * @param {Array} [options.filterRules] - extra filter rules (active rules are stripped)
 */
export function buildProjectsIndexParams(baseParams = {}, options = {}) {
  const { listView, activeOnly, filterRules = [] } = options;

  let activeParams;
  if (listView != null) {
    activeParams = projectsActiveQueryParams(listView);
  } else if (activeOnly === false) {
    activeParams = { include_inactive: "true" };
  } else {
    activeParams = { active: "true" };
  }

  const {
    filters: baseFilters,
    active: _dropActive,
    include_inactive: _dropIncludeInactive,
    activeOnly: _dropActiveOnly,
    ...rest
  } = baseParams;

  const mergedFilters = [
    ...stripActiveFilterRules(baseFilters),
    ...stripActiveFilterRules(filterRules),
  ];

  return {
    ...rest,
    ...activeParams,
    ...(mergedFilters.length > 0 ? { filters: mergedFilters } : {}),
  };
}
